import {
  BasicInfoBeneficiary,
  TermsBeneficiary,
  EvaluationFormBeneficiary,
  } from './components';
  import { getLocalString, localNames } from "utils/localisation.service";
  import locale from 'antd/lib/date-picker/locale/el_GR';
import { tabs as tabsBasicInfoBeneficiary } from './components/basicInfoBeneficiary/tabs';
import { tabs as tabsEvaluationFormBeneficiary } from './components/evaluationFormBeneficiary/tabs';

export const stepsBeneficiary = (disabledBeneficiaryTabs) => [
    {
      name: 'BASICFORM',
      label: 'Βασικά Στοιχεία',
      Component: BasicInfoBeneficiary,
      id: 0,
      subtabs: true,
      tabsComponent: tabsBasicInfoBeneficiary(),
    },
    {
      name: 'EVALUATIONFORM',
      label: 'Αξιολόγηση Αίτησης',
      Component: () => <EvaluationFormBeneficiary disabled={disabledBeneficiaryTabs}/>,
      id: 1,
      subtabs: true,
      tabsComponent: tabsEvaluationFormBeneficiary(),
    },
    {
      name: 'TERMS',
      label: 'Όροι και Προϋποθέσεις',
      Component: TermsBeneficiary,
      id: 2,
    },
  ];